export type NotificationStatusText =
| 'processed'
| 'delivered'
| 'deferred'
| 'bounce'
| 'dropped'
| string;

export const getStatusText = (statusText: NotificationStatusText): string => {
  switch (statusText) {
    case 'processed':
      return 'מעובד';
    case 'delivered':
      return 'סופק';
    case 'deferred':
      return 'נדחה';
    case 'bounce':
      return 'קפיצה';
    case 'dropped':
      return 'בוטלה';
    default:
      return statusText || '';
  }
};